import { lazy } from 'react';

export const PlayerAccountStatusForm = lazy(
  () => import('./PlayerAccountStatusForm'),
);
